import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "category/marketing-and-sales",
  "use": "category/marketing-and-sales-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"category/marketing-and-sales\"><g><path d=\"M14.49 9.12l-2.6-2.04L9.8 8.96 6.78 6.03l-2.6 5.87 1.25.55 1.81-4.07 2.53 2.46 2.18-1.97 2.8 2.2 2.13-2.9 1.03 1.11 1.01-.93-2.16-2.32z\" /><path d=\"M0 1.37h1.25v15.5H11.3v4L5.24 22.6l.37 1.32L12 22.13l6.38 1.79.37-1.32-6.07-1.69v-4h10.05V1.37H24V0H0zm2.62.1h18.74v14H2.62z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol